import * as React from 'react';
import UnAuthorizedLayout from '../layouts/unauth/UnAuthorizedLayout';
import {
    LoginPage,
    AccountConfirmationPage,
    EmailConfirmationPage,
    ResetPasswordPage,
} from '../pages';
import { Redirect, Switch, Route } from 'react-router';
import { Location } from 'history';

const UnAuthorizedHandler = ({ location }: UnAuthorizedHandlerProps) => (
    <UnAuthorizedLayout>
        <Switch location={location}>
            <Route path="/login" component={LoginPage} />
            <Route path="/confirm/:token" component={AccountConfirmationPage} />
            <Route path="/confirm-email/:token/" component={EmailConfirmationPage} />
            <Route path="/reset-password" component={ResetPasswordPage} />
            <Redirect to="/login" />
        </Switch>
    </UnAuthorizedLayout>
);

export default UnAuthorizedHandler;

interface UnAuthorizedHandlerProps {
    location: Location;
}
